module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "epub:type": "acknowledgments",
      "id": "_idContainer007"
    }
  }, [_c('h1', {
    staticClass: "Front-Title",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Michelle Branson and the "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("entire")]), _vm._v(" Gibbs Smith Team for your vote of confidence . . . again!")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Martha Hopkins of Terrace Partners, my agent, for your dedication, guidance, and patience. You keep me focused.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Kathleen, Jeanne, Linda, Dede, Lisa, and Lily for that push across the finish line that I so desperately needed! Thank you for your friendship, support, and encouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The Augusta Gourmet Club, for being my forever champions!")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("All my neighbors, friends, and family who served themselves up as my taste-testers.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "Photo of small jars of marmalade.",
      "src": "image/Brunch-Meyer_Marmalade-53.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8827ac84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lets-Brunch-Interiors_D-2.vue
// module id = 66
// module chunks = 0